import React, { ReactNode } from 'react'
import { Container } from './style'

interface BoxProps {
  children: ReactNode
}

const BoxWithAction: React.FC<BoxProps> = ({ children }) => {
  return <Container>{children}</Container>
}

export default BoxWithAction
